import { render, staticRenderFns } from "./PpvDateRangeInput.vue?vue&type=template&id=1c24c588&scoped=true"
import script from "./PpvDateRangeInput.vue?vue&type=script&lang=js"
export * from "./PpvDateRangeInput.vue?vue&type=script&lang=js"
import style0 from "./PpvDateRangeInput.vue?vue&type=style&index=0&id=1c24c588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24c588",
  null
  
)

export default component.exports